module.exports = __webpack_public_path__ + "static/GlitchlessSonyax51-8856728c02f70740cf25dfda5c970f33.png";